import { render } from "./TargetAudienceSectionMobile.vue?vue&type=template&id=1701fc44&scoped=true"
import script from "./TargetAudienceSectionMobile.vue?vue&type=script&lang=js"
export * from "./TargetAudienceSectionMobile.vue?vue&type=script&lang=js"

import "./TargetAudienceSectionMobile.vue?vue&type=style&index=0&id=1701fc44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1701fc44"]])

export default __exports__